/* __next_internal_client_entry_do_not_use__ Announcement,AnnouncementMuted auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1723))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.251Z
 */ export var Announcement = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M4.28599 8.17883H6.00028V15.036H4.28599C3.37668 15.036 2.50461 14.6748 1.86163 14.0318C1.21865 13.3888 0.857422 12.5167 0.857422 11.6074C0.857422 10.6981 1.21865 9.82602 1.86163 9.18304C2.50461 8.54006 3.37668 8.17883 4.28599 8.17883V8.17883Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M6 8.17882L21.7166 2.70339C21.8605 2.63817 22.0177 2.60741 22.1756 2.61356C22.3336 2.61971 22.4879 2.66259 22.6263 2.73881C22.7648 2.81502 22.8835 2.92247 22.9732 3.05261C23.0629 3.18276 23.121 3.33202 23.1429 3.48854V18.9411C23.1224 19.0929 23.0677 19.238 22.9828 19.3655C22.8979 19.493 22.785 19.5994 22.6528 19.6768C22.5206 19.7541 22.3726 19.8003 22.2198 19.8119C22.0671 19.8234 21.9138 19.8 21.7714 19.7434L6 15.036V8.17882Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M9.31059 21.3686C8.62261 21.2474 7.96916 20.9782 7.39538 20.5798C6.8216 20.1813 6.34117 19.663 5.98729 19.0607C5.63341 18.4584 5.41451 17.7864 5.34572 17.0913C5.27693 16.3961 5.35989 15.6943 5.58887 15.0343",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "Announcement", {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.default
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
export var AnnouncementMuted = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M4.28575 8.17871L6.00003 8.17871L6.00004 15.0359L4.28575 15.0359C3.37644 15.0359 2.50437 14.6746 1.86138 14.0316C1.2184 13.3887 0.857178 12.5166 0.857178 11.6073C0.857178 10.698 1.2184 9.8259 1.86138 9.18292C2.50437 8.53993 3.37644 8.17871 4.28575 8.17871V8.17871Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M6 8.17882L15.8714 4.73975M11 16.5284L21.7714 19.7434C21.9138 19.8 22.0671 19.8234 22.2198 19.8118C22.3726 19.8003 22.5206 19.7541 22.6528 19.6768C22.785 19.5994 22.8979 19.493 22.9828 19.3655C23.0677 19.238 23.1224 19.0929 23.1429 18.9411L23.1429 4.50049",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M9.31035 21.3686C8.62237 21.2474 7.96892 20.9783 7.39514 20.5798C7.30095 20.5144 7.20927 20.4457 7.12025 20.374",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M23 0.999996L1 23",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "AnnouncementMuted", {
    viewBox: "0 0 24 24",
    fill: "none"
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
